export const normalizeMoney = (value) => {
  const number = Number(value);

  return Number.isFinite(number)
    ? number
    : 0;
};


export const normalizeCount = (value) => {
  const number = Number(value);

  if (
    !Number.isFinite(number) ||
    number < 0
  ) {
    return 0;
  }

  return Math.floor(number);
};


export const parseProductMedia = (
  productImage
) => {
  let list = productImage;

  if (typeof list === "string") {
    try {
      list = JSON.parse(list);
    } catch (error) {
      list = [];
    }
  }

  if (!Array.isArray(list)) {
    return {
      images: [],
      hasFile: false
    };
  }

  const cover =
    list.find(
      item =>
        item?.type === "image"
    )?.data;

  const slideRaw =
    list.find(
      item =>
        item?.type === "slide"
    )?.data;

  const slides =
    Array.isArray(slideRaw)
      ? slideRaw
      : slideRaw
        ? [slideRaw]
        : [];

  const images =
    [
      cover,
      ...slides
    ].filter(Boolean);

  const uniqueImages =
    [...new Set(images)];

  const hasFile =
    Boolean(
      list.find(
        item =>
          item?.type === "file" &&
          item?.data
      )
    );

  return {
    images: uniqueImages,
    hasFile
  };
};
